export default __webpack_public_path__ + "static/media/player_3.485af0ca.png";